import React from "react";
import "./styles.scss";
import "./mobile.scss";
import { ButtonIcon, FormHeader } from "..";
import { getLanguage } from "../../utils/environment";
import moment from "moment";
import { motion } from "motion/react";

const lan = getLanguage();

const Index = ({ data, onChange, onClick, isBorder, item }) => {
  let inputElement = null;

  inputElement = (
    <>
      <div
        className={
          "d-flex flex-column justify-content-center align-items-center"
        }
      >
        {data.isImgUrl === true ? (
          <div className={"rcmw__img"}>
            <img
              src={require("../../assets/img/Rectangle 1.png")}
              alt="rach-card-img"
            />
          </div>
        ) : (
          <div className={"rcmw__img-wrp"}></div>
        )}
        <div className={"rcmw__header"}>{data.header}</div>
        <div className={"rcmw__subheader"}>{data.subheader}</div>
      </div>
    </>
  );

  return (
    <>
      <div className={`reach-card-main-wrapper ${data.mainLayerStyles}`}>
        <>{inputElement}</>
      </div>
    </>
  );
};

export default Index;
